import { render, staticRenderFns } from "./Editor.htm?vue&type=template&id=37cb6dea&scoped=true&"
import script from "./Editor.js?vue&type=script&lang=js&"
export * from "./Editor.js?vue&type=script&lang=js&"
import style0 from "./Editor.scss?vue&type=style&index=0&id=37cb6dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cb6dea",
  null
  
)

export default component.exports